export const sleep = (milliseconds: number) => {
    const date = Date.now();
    let currentDate = null;
    do {
        currentDate = Date.now();
    } while (currentDate - date < milliseconds);
};

export const getRandomElement = (array: any) => {
    return array[Math.floor(Math.random() * array.length)];
};

export const getRandomBetween = (min: number, max: number, rounded: boolean = false) => {
    if (!rounded) return Math.random() * (max - min) + min;
    else return Math.round(Math.random() * (max - min) + min);
};

export const getTotalFromArrayByPropertyName = (array: any[], propertyName: string) =>
    array.reduce((a: any, b: any) => {
        return a + b[propertyName];
    }, 0);
